import { handleActions } from "redux-actions";
import { COLLECTIONS } from "constants/action-types";

interface IState {
    pageCount: number;
    hasMore: boolean;
    isFetching: boolean;
    isAdding: boolean;
    result: string[];
    newMessages: any[];
    error?: boolean;
}

const initialState: IState = {
    pageCount: 0,
    hasMore: false,
    isFetching: false,
    isAdding: false,
    result: [],
    newMessages: [],
};

export const collectionChat = handleActions(
    {
        [COLLECTIONS.COLLECTION_CHAT.FETCH_MESSAGES.START]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
            };
        },
        [COLLECTIONS.COLLECTION_CHAT.FETCH_MESSAGES.COMPLETED]: (
            state: IState,
            { payload, error, meta }: any,
        ): IState => {
            if (error) {
                return {
                    ...state,
                    isFetching: false,
                    hasMore: false,
                };
            }

            return {
                ...state,
                hasMore: meta ? meta.hasMore : state.hasMore,
                isFetching: false,
                result: payload,
                pageCount: state.pageCount + 1,
            };
        },
        [COLLECTIONS.COLLECTION_CHAT.UPDATES.POLL]: (state: IState): IState => {
            return {
                ...state,
                // isFetching: true,
            };
        },
        [COLLECTIONS.COLLECTION_CHAT.CREATE_MESSAGE.START]: (state: IState): IState => {
            return {
                ...state,
                isAdding: true,
            };
        },
        [COLLECTIONS.COLLECTION_CHAT.CREATE_MESSAGE.COMPLETED]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return {
                    ...state,
                    error: payload,
                    isAdding: false,
                };
            }
            return {
                ...state,
                result: payload,
                isAdding: false,
            };
        },
        [COLLECTIONS.COLLECTION_CHAT.UPDATES.RECEIVED]: (state: IState, { payload, meta }: any): IState => {
            if (meta && meta.reset) {
                return {
                    ...state,
                    newMessages: [],
                };
            }
            return {
                ...state,
                newMessages: state.newMessages.concat(payload.messages),
            };
        },
        [COLLECTIONS.COLLECTION_CHAT.RESET]: (state: IState, { meta }: any): IState => {
            return {
                ...initialState,
                hasMore: meta ? meta.hasMore : false,
            };
        },
        [COLLECTIONS.COLLECTION_CHAT.UPDATES.UNSUBSCRIBE]: (state: IState): IState => {
            return {
                ...initialState,
                hasMore: state.hasMore,
            };
        },
    },
    initialState,
);
